import { useEffect, useState } from 'react'

const MANDATORY_INTRO_SLIDE_TIME = 2000

export const useEducationState = () => {
  const [isButtonEnabled, setIsButtonEnabled] = useState(false)
  const [isEducationStarted, setIsEducationStarted] = useState(false)

  useEffect(() => {
    const waitingTimer = setTimeout(() => {
      setIsButtonEnabled(true)
    }, MANDATORY_INTRO_SLIDE_TIME)

    return () => clearTimeout(waitingTimer)
  }, [])

  const startEducation = () => setIsEducationStarted(true)

  return {
    isButtonEnabled,
    isEducationStarted,
    startEducation,
  }
}
